/* Casilla «Quiero jugarlo desde mi propio perfil» en el «+» del catálogo (2026-10-29): cada botón trae la versión del
   perfil que le enviamos y la de su propio perfil; la casilla cambia cuál se agrega y el precio que se ve. */
document.addEventListener('change', (e) => {
  const c = e.target;
  if (!c.matches || !c.matches('[data-sheet-mejora]')) return;
  const sheet = c.closest('.pcard__sheet');
  if (!sheet) return;
  sheet.querySelectorAll('.pcard__opt[data-base]').forEach((b) => {
    const mas = c.checked && b.dataset.mas;
    b.dataset.addVariant = mas ? b.dataset.mas : b.dataset.base;
    const p = b.querySelector('.pcard__opt-price');
    if (p) p.textContent = mas ? b.dataset.masPrecio : b.dataset.basePrecio;
    b.disabled = Boolean(c.checked && !b.dataset.mas);
  });
});

/* La casilla de la página del juego (snippets/product-form.liquid): sola, o con versiones (data-mg) */
if (!window.__jgMejora) {
  window.__jgMejora = true;
  document.addEventListener('change', function (e) {
    var c = e.target;
    if (!c.matches || !c.matches('[data-mejora]')) return;
    var caja = c.closest('.mejora');
    var r = caja && caja.querySelector('[data-mejora-r="' + (c.checked ? 'mas' : 'base') + '"]');
    if (!r) return;
    r.checked = true;
    r.dispatchEvent(new Event('change', { bubbles: true }));
  });
}
if (!window.__jgMejoraGrupos) {
  window.__jgMejoraGrupos = true;
  var jgMg = function (caja) {
    var g = caja.querySelector('[data-mg-g]:checked');
    var c = caja.querySelector('[data-mg-check]');
    if (!g || !c) return;
    var sinMas = g.hasAttribute('data-mas-no');
    if (sinMas) c.checked = false;
    c.disabled = sinMas;
    c.closest('.mejora__op').classList.toggle('is-disabled', sinMas);
    var mas = caja.querySelector('[data-mg-mas]');
    if (mas) mas.textContent = g.getAttribute('data-mas');
    var r = caja.querySelector('[data-mg-r="' + g.value + '-' + (c.checked ? 'mas' : 'base') + '"]');
    if (!r || r.checked) return;
    r.checked = true;
    r.dispatchEvent(new Event('change', { bubbles: true }));
  };
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches('[data-mg-g], [data-mg-check]')) return;
    var caja = t.closest('[data-mg]');
    if (caja) jgMg(caja);
  });
}
